import React, { createContext, useContext, useState } from 'react';
import { CLOUD_API_HOST } from '../utils/cloudApi';

const ServerContext = createContext();

export const useServer = () => {
  const context = useContext(ServerContext);
  if (!context) {
    throw new Error("useServer must be used within a ServerProvider");
  }
  return context;
};

export const ServerProvider = ({ children }) => {
  // npm start → localhost:8000 for API, localhost:8050 for websockets.
  // `npm run build` → platform.ehaechie.com, `npm run build:testing` → core.ehaechie.com.
  const [serverIp, setServerIp] = useState(CLOUD_API_HOST);
  const [lanIp] = useState(CLOUD_API_HOST);

  const value = {
    serverIp,
    lanIp,
    setServerIp,
    loading: false,
    error: null,
  };

  return <ServerContext.Provider value={value}>{children}</ServerContext.Provider>;
};
